import React from "react";
import { Progress, Table, Button } from "antd";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next'
import { highlightSearchedText } from "../../../utils/TextHighlighter";
import { isEmptyObject, isEmptyValue, isUndefined } from "../../../utils/JsObjectHelper";
import { getColumnCustomAttributeProps, getColumnSearchProps, getColumnNameValueTag } from "../../../utils/TableHelper";
import { CopyOutlined, SwapOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
import cloneDeep from "lodash.clonedeep";
import EntryManipulationDialog from "./EntryManipulationDialog";
import { notificationSuccess } from "../../../utils/NotificationsHelper";
import MultipleAttributeChangesModal from "./MultipleAttributeChangesModal";


const deepEqual = require('deep-equal');

class EntryChildMultiSelection extends React.Component {

    state = {
        searchText: '',
        searchedColumn: '',
        childTablePageSize: (isEmptyObject(localStorage.getItem("childTablePageSize")) ? 30 : parseInt(localStorage.getItem("childTablePageSize"))),
        filteredTypes: [],
        selectedRowKeys: [],
        selectedEntries: [],
        showManipulationDialog: false,
        isCopyMode: false,
        newCopyId: null,
        visibleEditModal: false,
    };

    //add columns created, createdByUserName, updated, modifiedByUserName to table if they are selected in folder setup
    addTechnicalAttributes = (columnList, t) => {
        if (!isEmptyValue(this.props.folderProperties) &&
            !isEmptyValue(this.props.folderProperties.childrenDisplayTechAttr)) {
            if (this.props.folderProperties.childrenDisplayTechAttr.includes("created")) {
                columnList.push({ ...getColumnCustomAttributeProps("created", t('app.entry.tools.technical.tblCreated'), "date", t) });
            }
            if (this.props.folderProperties.childrenDisplayTechAttr.includes("createdByUserName")) {
                columnList.push({ ...getColumnCustomAttributeProps("createdByUserName", t('app.entry.tools.technical.tblCreatedBy'), "identity", t, { identityDataIndex: "createdByUserId" }) });
            }
            if (this.props.folderProperties.childrenDisplayTechAttr.includes("updated")) {
                columnList.push({ ...getColumnCustomAttributeProps("updated", t('app.entry.tools.technical.tblLastUpdated'), "date", t) });
            }
            if (this.props.folderProperties.childrenDisplayTechAttr.includes("modifiedByUserName")) {
                columnList.push({ ...getColumnCustomAttributeProps("modifiedByUserName", t('app.entry.tools.technical.tblLastUpdatedBy'), "identity", t, { identityDataIndex: "modifiedByUserId" }) });
            }
        }
    };

    addFillQualityColumn = (columnList, t) => {
        if (!isEmptyValue(this.props.folderProperties) &&
            !isEmptyValue(this.props.folderProperties.childrenDisplayTechAttr)) {
            if (this.props.folderProperties.childrenDisplayTechAttr.includes("fillQuality")) {
                let fillQualityColumnDefinition = {
                    title: t('app.entry.view.tblEntryFillQuality'),
                    //dataIndex: null,
                    key: 'fillQuality',
                    width: 100,
                    render: (text, record) => {
                        //let stats = ["success", "exception", "normal", "active"];
                        let thisStatus = "active";
                        let thisTitle = "";
                        let thisPercent = 100;

                        if (this.props.entryTypesRequestResult.getState().isDone()) {
                            //thisPercent = Math.floor(Math.random()*100)
                            let eType = this.props.entryTypesRequestResult.getData().find(eT => eT.type === record.type);

                            //PERCENTAGE calculation
                            //let filledCount = 0;
                            let filledCount = 1;
                            let percentageAttributes = null;
                            //Description uz se nenacita v seznamu ve slozce
                            /*if (!isEmptyValue(record.description) && !isEmptyValue(record.description.trim())) {
                                filledCount++;
                            } else {
                                thisTitle = t('app.entry.view.lblEntryFillQualityMissingDescription');
                            }*/
                            if (!isUndefined(eType)) {
                                percentageAttributes = eType.properties.attributes.filter(att => ["string", "number", "boolean", "date"].includes(att.type)).map(a => a.techName);
                                percentageAttributes.forEach(pA => {
                                    //Check if attribute is filled
                                    if (!isEmptyObject(record.properties) && !isEmptyValue(record.properties[pA])) {
                                        filledCount++;
                                    }
                                });
                                thisPercent = Math.floor((filledCount / (percentageAttributes.length + 1)) * 100);
                                if (thisPercent === 100) {
                                    thisStatus = "success";
                                } else {
                                    thisStatus = "normal";
                                } //MANDATORY check
                                let mandatoryAttributes = eType.properties.attributes.filter(att => att.isRequired && ["string", "number", "boolean", "date"].includes(att.type)).map(a => a.techName);
                                mandatoryAttributes.forEach(mA => {
                                    //Check if mandatory attribute is missing
                                    if (isEmptyObject(record.properties) || (!isEmptyObject(record.properties) && isEmptyValue(record.properties[mA]))) {
                                        thisStatus = "exception";
                                        thisTitle = t('app.entry.view.lblEntryFillQualityMissingMandatory');
                                        return;
                                    }
                                });
                            }
                        }
                        else {
                            thisStatus = "exception";
                        }

                        return <Progress title={thisTitle} percent={thisPercent} size="small" status={thisStatus} />;
                    }
                };

                columnList.push(fillQualityColumnDefinition);
            }
        }
    };

    //add all user defined columns from Entry properties if they are selected in this Folder setup
    addUserAttributes = (columnList, usedTypesInData, filteredTypes, t) => {
        if (!isEmptyValue(this.props.folderProperties) && !isEmptyValue(this.props.folderProperties.childrenDisplayAttributes)) {
            let attDefs = [];
            if (this.props.entryTypesRequestResult.getState().isDone() &&
                !isEmptyObject(this.props.entryTypesRequestResult.getData()) &&
                !isEmptyValue(this.props.folderProperties.childObjectEntryTypes)) {
                //filter only types in folder and types currently in data => dont display empty columns
                let eTypes = this.props.entryTypesRequestResult.getData().filter(eT =>
                    //types allowed in folder
                    this.props.folderProperties.childObjectEntryTypes.includes(eT.type) &&
                    //types in data
                    usedTypesInData.includes(eT.type) &&
                    //types filtered in table
                    (isEmptyValue(filteredTypes) ? true : filteredTypes.includes(eT.name))
                );
                eTypes.forEach(eT => {
                    if (!isEmptyValue(eT.properties) && !isEmptyValue(eT.properties.attributes)) {
                        eT.properties.attributes.forEach(att => {
                            if (this.props.folderProperties.childrenDisplayAttributes.includes(att.techName) &&
                                isEmptyObject(attDefs.find(a => a.techName === att.techName))) {
                                attDefs.push(att);
                            }
                        });
                    }
                });
            }
            this.props.folderProperties.childrenDisplayAttributes.forEach(att => {
                let attName = att;
                let attType = "attribute";
                let attDef = attDefs.find(a => a.techName === att);
                if (!isEmptyObject(attDef)) {
                    attName = attDef.name;
                    attType = attDef.type;
                    if (attDef.type === "lov") {
                        columnList.push({ ...getColumnNameValueTag(["properties", att], attName, attDef, t) });
                    } else {
                        columnList.push({ ...getColumnCustomAttributeProps(["properties", att], attName, attType, t) });
                    }
                }
            });
        }
    };

    //Renderer for Entry name column. Renders it as link with ability to highlight quick search results
    handleRenderTextColumn = (text, record, dataIndex) => {
        return this.state.searchedColumn === dataIndex ? (
            <Link to={`/entry/${record.id}`}>{highlightSearchedText(text, this.state.searchText)}</Link>
        ) : (
            <Link to={`/entry/${record.id}`}>{text}</Link>
        );
    };

    //set filters
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    //reset filters
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    showTotal = (total) => {
        return `(${total})`;
    };

    handlePageSizeChanged = (current, page) => {
        localStorage.setItem("childTablePageSize", page);
        this.setState({ childTablePageSize: page });
    };

    handleTableChange = (pagination, filters, sorter) => {
        console.log('Various parameters', filters, sorter);
        if (!isUndefined(filters.entryType) && !deepEqual(filters.entryType, this.state.filteredTypes)) {
            this.setState({ filteredTypes: filters.entryType })
        } else {
            if (isUndefined(filters.entryType) && !isEmptyValue(this.state.filteredTypes)) {
                this.setState({ filteredTypes: [] })
            }
        }
    };
    onSelectChange = (newSelectedRow) => {
        let data = cloneDeep(this.state.selectedEntries);
        let newSelectedRowKeys = cloneDeep(this.state.selectedRowKeys);
        let del = newSelectedRowKeys.findIndex((el) => el === newSelectedRow.id);
        let delEnt = data.findIndex((el) => el.id === newSelectedRow.id);
        if (del !== -1 && delEnt !== -1) {
            data.splice(delEnt, 1);
            newSelectedRowKeys.splice(del, 1);
        }
        else {
            data.push(newSelectedRow);
            newSelectedRowKeys.push(newSelectedRow.id);
        }
        this.setState({ selectedRowKeys: newSelectedRowKeys, selectedEntries: data });
    };
    handleDialogClose = () => {
        if (this.state.newCopyId) {
            this.props.updateChildren(this.props.entryRequestResult.getData().id);
        }

        this.setState({ showManipulationDialog: false, newCopyId: null });
    };
    onMoveClick = () => {
        this.setState({ showManipulationDialog: true, isCopyMode: false });
    };
    onCopyClick = () => {
        this.setState({ showManipulationDialog: true, isCopyMode: true });
    };
    handleManipulationAction = (manipulationObject) => {
        let completedActionsCount = 1;
        if (this.state.isCopyMode) {
            this.state.selectedEntries.forEach((entry) => this.props.onCopy(entry.id, manipulationObject, (newEntryId) => this.handleAfterAction(manipulationObject.targetFolderId, completedActionsCount++)));
        } else {
            this.state.selectedEntries.forEach((entry) => this.props.onMove(entry.id, manipulationObject, (newEntryId) => this.handleAfterAction(manipulationObject.targetFolderId, completedActionsCount++)));
        }
    };

    handleAfterAction = (folderId, completedActionsCount) => {
        const counter = document.getElementById('counter');
        if (counter) {
            counter.innerText = completedActionsCount;
        }
        if (completedActionsCount >= this.state.selectedEntries.length - 1) {
            this.setState({ newCopyId: folderId });
            notificationSuccess("Success");
        }
    };
    selectAll = () => {
        if (this.state.selectedRowKeys.length === this.props.childsDataList.length) {
            this.setState({ selectedRowKeys: [], selectedEntries: [] });
        }
        else {
            let newSelectedRowKeys = [];
            this.props.childsDataList.forEach((el) => newSelectedRowKeys.push(el.id));
            this.setState({ selectedRowKeys: newSelectedRowKeys, selectedEntries: this.props.childsDataList });
        }
    }
    onEditClick = () => {
        this.setState({ visibleEditModal: true })
    }
    clickCancelEdit = () => {
        this.setState({ visibleEditModal: false })
    }

    render() {
        const { t } = this.props;
        let parent = this.props.entryRequestResult.getData();
        let columnsChilds = [
            {
                title: t('app.entry.view.tblEntriesName'),
                dataIndex: 'entry',
                key: 'entry',
                fixed: 'left',
                ...getColumnSearchProps('entry', this.handleSearch, this.handleReset, this.handleRenderTextColumn, t, this.searchInput),
            },
            {
                title: t('app.entry.view.tblEntriesType', t),
                dataIndex: 'entryType',
                key: 'entryType',
                filters: Array.from(new Set(this.props.childsDataList.map(itm => itm.entryType))).map(
                    itmName => {
                        return { text: itmName, value: itmName };
                    }
                ),
                onFilter: (value, record) => record.entryType === value
                // record.entryType.indexOf(value) === 0
            }
        ];
        let disabledEdit = this.state.selectedEntries.map(item => item.type).filter((item, index, self) => self.indexOf(item) === index);
        let typesInDataArr = this.props.childsDataList.map(d => d.type);

        if (!isEmptyValue(this.props.folderProperties) && this.props.folderProperties.displayTechAttributesFirst) {
            this.addTechnicalAttributes(columnsChilds, t);
            this.addUserAttributes(columnsChilds, typesInDataArr, this.state.filteredTypes, t);
        } else {
            this.addUserAttributes(columnsChilds, typesInDataArr, this.state.filteredTypes, t);
            this.addTechnicalAttributes(columnsChilds, t);
        }

        this.addFillQualityColumn(columnsChilds, t);

        let paginationSetup = {
            showSizeChanger: true,
            size: "small",
            showTotal: this.showTotal,
            defaultPageSize: this.state.childTablePageSize,
            pageSizeOptions: ['10', '20', '30', '50', '100'],
            onShowSizeChange: this.handlePageSizeChanged
        };
        const { selectedRowKeys, } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onSelectAll: this.selectAll,
            onSelect: this.onSelectChange,
        };
        let multipleAttributeChanges = null;
        if (disabledEdit.length === 1) {
            multipleAttributeChanges = <MultipleAttributeChangesModal
                type={disabledEdit}
                entryTypesRequestResult={this.props.entryTypesRequestResult}
                visible={this.state.visibleEditModal}
                cancel={this.clickCancelEdit}
                entriesId={this.state.selectedRowKeys}
            />
        }

        return <>

            <Table //title={() => <div className="childTableTitle">{t('app.entry.view.tblEntriesTitle')}</div>} 
                title={() => <> {this.props.tableTitle}   <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button key="move" onClick={() => this.props.handleTypeChange("table")}><CloseCircleOutlined />{t('app.entry.view.btnMultiSelectionCancel')}</Button>
                    <Button disabled={this.state.selectedEntries.length === 0} style={{ marginLeft: '10px' }} icon={<SwapOutlined />} onClick={this.onMoveClick}>{t('app.entry.view.btnMultiSelectionMove')}</Button>
                    <Button disabled={this.state.selectedEntries.length === 0} style={{ marginLeft: '10px' }} icon={<CopyOutlined />} onClick={this.onCopyClick}>{t('app.entry.view.btnMultiSelectionCopy')}</Button> 
                    <Button disabled={disabledEdit.length === 1 ? false : true || this.state.selectedEntries.length === 0} style={{ marginLeft: '10px' }} icon={<EditOutlined />} onClick={this.onEditClick}>{t('app.entry.view.btnMultiSelectionEditAtt')}</Button>
                </div></>}
                rowSelection={rowSelection}
                rowKey={record => record.id}
                columns={columnsChilds}
                dataSource={this.props.childsDataList}
                size="small"
                pagination={paginationSetup}
                scroll={{ x: true }}
                onChange={this.handleTableChange}
                className='EntryChildTable'
            />
            <EntryManipulationDialog
                parent={parent}
                entry={this.state.selectedEntries}
                isVisible={this.state.showManipulationDialog}
                isCopyMode={this.state.isCopyMode}
                onAction={this.handleManipulationAction}
                onCancel={this.handleDialogClose}
                newAfterCopyEntryId={this.state.newCopyId}
                multiMod={true}
            />
            {multipleAttributeChanges}
        </>;

    }
}

export default withTranslation()(EntryChildMultiSelection);

